import EventManager from "../eventManager.js";

export default class MessageBoxManager extends EventManager {

    constructor($container, options) {

        super();

        this.settings = $.extend({}, {
                extraClasses: '',
                method: 'prependTo'
            }, options);

        this.$container = $container;

        this.messageBoxes = [];
    }

    notify(message, options) {
        let settings = $.extend({}, {
                type: 'info',
                scroll: false,
                selector: null
            }, options);

        if (settings.selector && this.getNotificationsBySelector(settings.selector).length > 0) {
            return;
        }

        let icon = 'info-circle';

        switch (settings.type) {
            case 'warning': icon = 'exclamation-triangle'; break;
            case 'error': icon = 'exclamation-triangle'; break;
        }
        
        if (settings.type === 'warning' || settings.type === 'error') {
          app.getLogsManagerInstance()[settings.type]({
            message: message
          })
        }

        let $messageBox = $(`
                <div class="message-box ${this.settings.extraClasses} ${settings.type}">
                    <div class="icon">
                        <i class="fa fa-${icon}" aria-hidden="true"></i>
                    </div>
                    ${message}
                </div>
            `);

        if (settings.selector) {
            $messageBox.data('selector', settings.selector);
        }

        this.messageBoxes.push($messageBox[this.settings.method].apply($messageBox, [this.$container]));

        if (settings.scroll) {
            let $fixed = $('#header');
            if ($fixed.css('position') != 'fixed') {
                $fixed = $('#header').find('.content');
            }

            $('html, body').stop();
            $('html, body').animate(
                    { scrollTop: $messageBox.offset().top - $fixed.height() },
                    'slow'
                );
        }

    }

    getNotificationsBySelector(selector) {
        return this.messageBoxes.filter( $mb => $mb.data('selector') === selector );
    }

    clearNotifications() {
        this.messageBoxes.map(mb => mb.remove());
        this.messageBoxes = [];
    }

    notifyUnexpectedError() {
        this.notify(`
                <h2>Une erreur inattendue est survenue</h2>
                <p>Essayez de recharcher la page, revenir plus tard ou <a href="nous-contacter,bebe,contact,contact_mail,3.couche-lavable.html" target="blank">contacter notre service client</a></p>
            `,
            { type: 'error', scroll: true });
    }

}
